export default __webpack_public_path__ + "static/media/receipt-details.ab99bb76.png";